import { ReactNode } from 'react'

import './Marquee.css'

interface MarqueeProps {
  children: ReactNode[]
  duration?: number
}

export default function Marquee({ children, duration = 20 }: MarqueeProps) {
  return (
    <div className="marquee">
      <div
        className="marquee-content"
        style={{ animationDuration: `${duration}s` }}
      >
        {children.map((child, i) => (
          <div key={`set1-${i}`} className="child-marquee">
            {child}
          </div>
        ))}
      </div>
      <div
        className="marquee-content"
        style={{ animationDuration: `${duration}s` }}
      >
        {children.map((child, i) => (
          <div key={`set2-${i}`} className="child-marquee">
            {child}
          </div>
        ))}
      </div>
      <div
        className="marquee-content"
        style={{ animationDuration: `${duration}s` }}
      >
        {children.map((child, i) => (
          <div key={`set3-${i}`} className="child-marquee">
            {child}
          </div>
        ))}
      </div>
      <div
        className="marquee-content"
        style={{ animationDuration: `${duration}s` }}
      >
        {children.map((child, i) => (
          <div key={`set4-${i}`} className="child-marquee">
            {child}
          </div>
        ))}
      </div>
    </div>
  )
}
